import React from 'react';
import { AsyncSwitch } from 'src/core/engine/router';
import { Route } from 'react-router';
import { paths } from 'src/config';
import { BlogPostsContainer } from 'src/components/Blog/BlogPostsContainer';
import { BlogPost } from 'src/components/Blog/BlogPost';

export const BlogRouter: React.FC = () => (
    <AsyncSwitch base="/blog">
        <Route path={paths.blog} element={<BlogPostsContainer />} />
        {/* Magefan posts are linked as /blog/:identifier */}
        <Route path={`${paths.blog}/:id`} element={<BlogPost />} />
        {/* Some Magento URLs also use /blog/post/:identifier */}
        <Route path={`${paths.blog}/post/:id`} element={<BlogPost />} />
    </AsyncSwitch>
);
